import * as React from "react";
import type { SVGProps } from "react";
const SvgMountainsSlope = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17.691 20H21l-.01.01c.34 0 .66-.18.84-.46.19-.28.22-.64.08-.95L15.65 4.5c-.4-.91-1.21-1.49-2.1-1.5-.85 0-1.7.53-2.12 1.41l-1.22 2.53c-.42-.33-.91-.49-1.46-.48-.89.04-1.66.61-2.05 1.52L2.08 18.6c-.14.31-.11.67.08.95.19.28.5.45.84.45h14.56l-.01.01a.995.995 0 0 0 .141-.01Zm.672-2h1.107L13.83 5.31c-.1-.23-.23-.31-.3-.31-.1 0-.21.11-.29.28l-1.96 4.06c-.16.34-.5.56-.87.57-.38 0-.72-.19-.9-.52l-.37-.68c-.08-.15-.18-.25-.28-.24-.08 0-.21.09-.3.31L4.53 18h10.939c-.957-.383-2.36-.625-3.439-.81l-.023-.004c-2.32-.408-4.327-.761-4.327-2.406 0-1.318 1.536-1.57 3.67-1.918l.01-.002.37-.062.46-.078c-.38-.1-.81-.2-1.22-.26a.996.996 0 0 1-.83-1.14.99.99 0 0 1 1.14-.83c2.71.42 4.09 1.24 4.09 2.43 0 1.318-1.536 1.57-3.67 1.918l-.01.002c-.21.04-.47.08-.73.12.47.1.99.19 1.41.26 2.37.413 5.243.916 5.993 2.78Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgMountainsSlope;
